const codePad = (code) => (code?.charAt(0) === "0" ? code : `0${code}`); // solves most cases, but 0 pad is inconsistent

const purchaseAttributesTransform = (gqlData) => {
  const {
    allInseam,
    allSize,
    colorDriver,
    colors,
    sizeDriver,
    sizeGuide: { url: sgUrl, category: sgCategory } = {},
    reviews: { count: reviewsCount } = {},
  } = gqlData;

  return {
    "bopis-color-driver": null, // ??
    "all-inseam": allInseam,
    "selected-swatch-index": 0, // ??
    "all-size": allSize?.map(({ size: name, available }) => ({
      name,
      state: available ? "available" : "outofstock",
    })),
    "find-in-store": {
      url: "#",
      text: "Find in Store",
    }, // ??
    "share-url": "#", // ??
    "size-driver": sizeDriver,
    "add-to-cart": {
      url: "",
      text: "",
    },
    "size-guide-url": sgUrl,
    reviews: {
      count: reviewsCount, // can be 0 or null on legacy, inconsistent
      url: "#", // always the same
    },
    sizeGuideCategory: sgCategory,
    "selected-swatch-color": "", // ??
    "color-driver": colorDriver?.map(({ color, sizes }) => {
      return { color, sizes };
    }),
    "all-color":
      colors?.map(({ code, slug }) => ({
        "color-code": code,
        "display-name": `${codePad(code)} - ${slug} ${slug}`, // slug is sometimes the same `code` in graph data
      })) ?? [], // best guess/match we can do. not used??
  };
};

export default purchaseAttributesTransform;
